import { notEmpty } from "@crehana/utils";
var parseTrailerSources = function parseTrailerSources(_ref) {
  var trailerSource = _ref.trailerSource;
  return (trailerSource || []).filter(notEmpty).filter(function (source) {
    return !!source.videoUrl;
  });
};
export default parseTrailerSources;